import React, { useEffect } from 'react';
import $ from 'jquery';
import UpdateStatus from './UpdateStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash,faEye} from '@fortawesome/free-solid-svg-icons';
const TrackingSimpleTables = ({columns, rows,handleSubmit,handleShowProducts}) => {
    useEffect(() => {
        //initialize datatable
        if (!$.fn.dataTable.isDataTable('#datatable')) {
            $(document).ready(function () {
                setTimeout(function () {
                    $('#datatable').DataTable({
                        retrieve: true,
                        pageLength: 5,
                        lengthMenu: [[5, 10, 15, 20, 25, -1], [5, 10, 15, 20, 25, 'All']]
                    });
                }, 10);
            });
        }
    });
    console.log('rows', rows);
    return (
        <div className='table-responsive'>
            <table id="datatable" className="table table-hover">
                <thead>
                    <tr>
                        {columns && columns.map((col, i ) => (
                            <th key={i.toString()} scope="col">{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows && rows.map((row, i) => (
                        <tr key={i.toString()}>
                            {Object.values(row).map((value, i) => (
                                <td key={value + i + 1}>{value}</td>
                            ))}
                            <td><UpdateStatus tracking={row}/>   </td>
                            <td><button onClick={()=>handleSubmit(row.trackingId)}><FontAwesomeIcon icon={faTrash} /></button></td>
                            <td><button onClick={()=>handleShowProducts(row.trackingId)}><FontAwesomeIcon icon={faEye} /></button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TrackingSimpleTables;